
export type AssetImagesJSON = {
  asset_id?: number;
  url?: string;
  file_name?: string;
  updated_at?: string;
};

export class AssetImage {
  constructor(
    public index?: number,
    public assetId?: number,
    public estateId?: number,
    public fileName?: string,
    public extension?: string,
    public url?: string,
    public updatedAt?: Date
  ) {}
  static fromJSON = (
    json: AssetImagesJSON,
    index: number,
    estateId?: number
  ): AssetImage => {
    const extension = json?.url?.split(".")[1];
    return new AssetImage(
      index,
      json.asset_id,
      estateId,
      json.file_name,
      extension,
      json.url,
      json.updated_at ? new Date(json.updated_at) : undefined
    );
  };

  static fromStatic = (fileName: string): AssetImage => {
    return new AssetImage(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      fileName
    );
  };
}
